// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"lP-z","categoryName":"mP-z","categoryNameSearchHeader":"nP-z","categoryContent":"oP-z","bottomAligned":"pP-z","image":"qP-z","imageNoBackground":"rP-z"};